import { parseJSON, parseString } from './common';
import { EMPTY_OBJECT, EMPTY_STRING } from './empty';
// import logger, { TAG_NAMES } from 'utils/Logger';
import { _includes, _isEmpty, _isObject } from './zupeeLodash';

const _tempObject = {};

export const storeData = async (key, value) => {
  try {
    if (_tempObject.hasOwnProperty(key)) {
      delete _tempObject[key];
    }
    const valueToStore = typeof value !== 'string' ? parseString(value) : value;
    localStorage.setItem(key, valueToStore);
    return Promise.resolve(true);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure storeData', {
    //   isBreadcrumb: true,
    //   data: { key },
    //   error,
    // });
    return Promise.resolve(false);
  }
};

export const readData = async (key, shouldCache = true) => {
  try {
    if (shouldCache && _tempObject.hasOwnProperty(key)) {
      return Promise.resolve(_tempObject[key]);
    }
    const res = localStorage.getItem(key);
    if (shouldCache && !_isEmpty(res)) {
      _tempObject[key] = res;
    }
    return Promise.resolve(res);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure readData', {
    //   isBreadcrumb: true,
    //   data: { key },
    //   error,
    // });
    return Promise.resolve(EMPTY_STRING);
  }
};

export const readJsonData = async (key, shouldCache = true) => {
  try {
    if (shouldCache && _tempObject.hasOwnProperty(key)) {
      return Promise.resolve(_tempObject[key]);
    }
    const res = parseJSON(localStorage.getItem(key));
    if (shouldCache && !_isEmpty(res)) {
      _tempObject[key] = res;
    }
    return Promise.resolve(res);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure readJsonData', {
    //   isBreadcrumb: true,
    //   data: { key },
    //   error,
    // });
    return Promise.resolve(EMPTY_OBJECT);
  }
};

export const mergeData = async (key, value) => {
  try {
    if (_tempObject.hasOwnProperty(key)) {
      delete _tempObject[key];
    }
    const existingData = parseJSON(localStorage.getItem(key)) || {};
    const newData = _isObject(value) ? { ...existingData, ...value } : value;
    localStorage.setItem(key, parseString(newData));
    return Promise.resolve();
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure mergeData', {
    //   isBreadcrumb: true,
    //   data: { key },
    //   error,
    // });
    return Promise.resolve(false);
  }
};

export const getAllKeys = async () => {
  try {
    const keys = Object.keys(localStorage);
    return Promise.resolve(keys);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure getAllKeys', {
    //   isBreadcrumb: true,
    //   error,
    // });
    return Promise.resolve([]);
  }
};

export const removeItem = async (key) => {
  try {
    if (_tempObject.hasOwnProperty(key)) {
      delete _tempObject[key];
    }
    localStorage.removeItem(key);
    return Promise.resolve(true);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure removeItem', {
    //   isBreadcrumb: true,
    //   data: { key },
    //   error,
    // });
    return Promise.resolve(false);
  }
};

export const removeKeysExcept = async (ignoreKeys) => {
  try {
    const keys = Object.keys(localStorage);
    const filteredKeys = keys.filter((key) => !_includes(ignoreKeys, key));
    filteredKeys.forEach((key) => localStorage.removeItem(key));
    return Promise.resolve(true);
  } catch (error) {
    // logger(TAG_NAMES.STORAGE, 'Unsecure removeKeys', {
    //   isBreadcrumb: true,
    //   error,
    // });
    return Promise.resolve(false);
  }
};
